import Footer from '@components/Footer';
import { connect } from 'react-redux';
import type { ApplicationState } from '../store';

export default connect(
    (state: ApplicationState) => ({
        work: state.user.work,
    })
)(Footer as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
